"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkOrder = void 0;
const Base_1 = require("./Base");
const index_1 = require("../index");
class WorkOrder extends Base_1.Base {
    work_order_id = '';
    date = null;
    agent = null;
    worker = null;
    workers = [];
    location = null;
    order = null;
    state = 'Draft';
    notes = '';
    items = [];
    packages = [];
    agents = [];
    followers = [];
    roles = [];
    _m = ['name', 'items', 'agent', 'worker', 'location', 'order', 'work_order_id'];
    _s = ['items', 'agent', 'worker', 'location', 'order', 'work_order_id', 'state'];
    get name() {
        return this.toString();
    }
    constructor(data, olMap) {
        super('work_orders', 12);
        (0, index_1.setObjectProperties)(this, data, olMap, WorkOrder);
    }
    toString() {
        return `WorkOrder: ${this.work_order_id}: ${this.location?.nickname || this.location?.name || ''}`;
    }
    // loadAll(opts?: ILoadAllOpts, stack?: string[]) {
    //     console.log('NAH');
    //     return;
    // }
    async toSearchJSON(opts) {
        await this.loadAll(opts);
        let r = await super.toSearchJSON(opts);
        r.order = await this.order.toSearchJSON(opts);
        return r;
    }
}
exports.WorkOrder = WorkOrder;
index_1.olm.work_orders = (ref, map) => {
    return new WorkOrder(ref, map);
};
